import datacentral from '@/utils/axios/datacentral'
import { ResponsePresignedURL, VCard } from '../types/response'
import { ErrorResponse, ResponseArray, ResponseObject } from '@/types/shared'
import { VCardCreatePayload } from '../types/payload'
import axios from 'axios'
import qs from 'qs'

export const getVCardsList = async (payload: Record<string, any>) => {
    const response = await datacentral.get<ResponseArray<VCard>>(
        `/employees/vcards?${qs.stringify(payload)}`
    )
    return response?.data
}

export const getVCardByID = async (id: number) => {
    const response = await datacentral.get<Promise<ResponseObject<VCard>>>(
        `/employees/vcards/${id}`
    )
    return response?.data
}

export const getVCardByEmployeeID = async () => {
    const response = await datacentral.get<Promise<ResponseObject<VCard>>>(
        `employees/vcards/current`
    )
    return response?.data
}

export const getPresignedURL = async (payload: { key: string }) => {
    const response = await datacentral.post<Promise<ResponsePresignedURL>>(
        `/employees/vcards/presigned_url`,
        payload
    )
    return response?.data
}

export const createVCard = async (
    payload: VCardCreatePayload
): Promise<ResponseObject<VCard> | ErrorResponse> => {
    const response = await datacentral.post(`/employees/vcards`, payload)
    return response?.data
}

export const deleteVCard = async (
    id: number
): Promise<ResponseObject<VCard> | ErrorResponse> => {
    const response = await datacentral.delete(`/employees/vcards/${id}`)
    return response?.data
}

export const UpdateVCard = async (payload: {
    id: number
    vCard: VCardCreatePayload
}): Promise<ResponseObject<VCard> | ErrorResponse> => {
    const response = await datacentral.put(
        `/employees/vcards/${payload.id}`,
        payload.vCard
    )
    return response?.data
}

export const getVCardByUUID = async (uuid: string) => {
    const response = await axios.get<Promise<ResponseObject<VCard>>>(
        `${import.meta.env.APP_API_URL}/vcards/public/${uuid}`
    )
    return response?.data
}
